export const useAuth = () => {
  const userCookie = useCookie<string | null>("auth_user", {
    default: () => null,
    maxAge: 60 * 60 * 24 * 7, // 7 jours
    watch: true,
    path: '/',
  });
  const user = useState<string | null>("auth_user_state", () => userCookie.value);

  // --- HYDRATION FIX ---
  // S'active uniquement côté client : si le SSR a été court-circuité par un cache Nginx ou Cloudflare
  // qui a supprimé le header Cookie, user.value sera `null`.
  // On restaure instantanément la session car document.cookie l'a conservée sur le navigateur.
  if (import.meta.client && userCookie.value && !user.value) {
    user.value = userCookie.value;
  }

  const otpSent = useState<boolean>("otp_sent", () => false);
  const otpCode = useState<string>("otp_code", () => "");
  const authError = useState<string>("auth_error", () => "");

  const login = async (email: string) => {
    authError.value = "";
    if (!email.endsWith("@xpirience.ch") && email !== "test@test.com") {
      authError.value = "Email non autorisé";
      return false;
    }

    authError.value = "";
    try {
      await $fetch("/api/auth/send-otp", {
        method: "POST",
        body: { email },
      });
      otpSent.value = true;
      return true;
    } catch (e: any) {
      authError.value =
        e.data?.statusMessage || "Erreur lors de l'envoi de l'email.";
      return false;
    }
  };

  const verifyOtp = async (email: string, code: string) => {
    try {
      const response = await $fetch<{ success: boolean; user: string }>(
        "/api/auth/verify-otp",
        {
          method: "POST",
          body: { email, otp: code },
        },
      );
      if (response.success) {
        userCookie.value = response.user;
        user.value = response.user;
        return true;
      }
      return false;
    } catch (e: any) {
      authError.value = e.data?.statusMessage || "Code OTP invalide.";
      return false;
    }
  };

  const logout = async () => {
    try {
      await $fetch("/api/auth/logout", { method: "POST" });
    } catch (e) {
      console.error("Logout error", e);
    }
    userCookie.value = null;
    user.value = null;
    otpSent.value = false;
    otpCode.value = "";
    authError.value = "";
    navigateTo("/");
  };

  return {
    user,
    otpSent,
    otpCode,
    authError,
    login,
    verifyOtp,
    logout,
  };
};
